import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  user-select: none;\n\n  &:after {\n    content: '';\n    width: calc(100% - 1.5rem);\n    left: 0.75rem;\n    height: 1px;\n    background: ", ";\n    display: block;\n    position: absolute;\n    top: 50%;\n    left: 0;\n  }\n\n  .step {\n    cursor: default;\n    font-size: ", ";\n    color: ", ";\n    width: 1.5rem;\n    height: 1.5rem;\n    border: 1px solid ", ";\n    background: ", ";\n    border-radius: 1.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    position: relative;\n    z-index: 2;\n  }\n\n  .step.done {\n    cursor: pointer;\n  }\n\n  .step.current {\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n    font-weight: 600;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var StyledSteps = styled.div(_templateObject(), function (props) {
  return props.theme.colors.inputBorder;
}, function (props) {
  return props.theme.fontSizes.label;
}, function (props) {
  return props.theme.colors.accent7;
}, function (props) {
  return props.theme.colors.inputBorder;
}, function (props) {
  return props.theme.colors.accent1;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.labelInverted;
});

function Steps(_ref) {
  var amount = _ref.amount,
      current = _ref.current,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _onClick = _ref.onClick;
  return _jsx(StyledSteps, Object.assign({
    className: "steps ".concat(className)
  }, {
    children: Array.from(Array(amount)).map(function (_, i) {
      return _jsx("div", Object.assign({
        onClick: function onClick() {
          return _onClick && _onClick(i + 1);
        },
        className: "step ".concat(current === i + 1 ? 'current' : '', " ").concat(i < current ? 'done' : '')
      }, {
        children: i + 1
      }), i);
    })
  }), void 0);
}

export default Steps;